module.exports = __webpack_public_path__ + "grape_coupon-caa8e.svg";